// src/services/api.ts
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/api/',
  withCredentials: true,                // keeps Django session if you use it
});

// attach token from localStorage (same key you already store after login)
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("testinvest_token");
  if (token) cfg.headers.Authorization = `Token ${token}`;
  return cfg;
});

export default api;
